// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9lg11","container":"Home_container__2HNFu"};